import * as Constants from "../constants";

export const getCourse = () => ({
  type: Constants.GET_COURSE,
});

export const getCourseSuccess = (data) => ({
  type: Constants.GET_COURSE_SUCCESS,
  payload: data,
});

export const getCourseError = (error) => ({
  type: Constants.GET_COURSE_ERROR,
  error,
});
